/**
 * if a user cannot place an order because he does not have enough buying power left in his account.
 * {
	"messageType": "alertNotification",
	"notificationId": 1645221981513,
	"notificationDetails": {"errorType":"ORDER_VALIDATION","notificationType":"ERROR","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "NOT_ENOUGH_BUYING_POWER",
	"statusDetails": {"orderAction":"OPENING_ORDER","orderSymbol":"XYZ"},
	"date": "2022-02-18T17:06:22.317-0500",
	"timestamp": "1645221982318"
}

 * @param {*} statusDetails 
 * @returns an object with feilds:
 * 1) orderAction: one of: OPENING_ORDER, CLOSING_ORDER, MODIFY_LIMIT_PRICE, MODIFY_QUANTITY
 * 2) symbol: the symbol this action was placed on
 */
export function notEnoughBuyingPowerParser(statusDetails) {
  const parsedObj = {
    orderAction: null,
    symbol: null,
  };
  if (statusDetails) {
    parsedObj.orderAction = statusDetails.orderAction ?? null;
    parsedObj.symbol = statusDetails.orderSymbol ?? null;
  }

  return parsedObj;
}
